/**
 * This is the top level of the application.
 *
 * In the app page data and props can be passed generically to any page, so if certain data (like the current user)
 * is needed on every page it can be added here and will be made available automatically as props on any page.
 */
import JobiqoApp from '~/jobiqo/pages/_app';
import '~/jobiqo-cl-vanilla/src/theme/theme.scss';
import '~/theme/theme.scss';
import '~/jobiqo-cl-vanilla/src/global/global.scss';
import '~/jobiqo-cl-vanilla/src/global/appGlobal.scss';
export default JobiqoApp;
